import React, { Suspense } from 'react';
import propTypes from 'prop-types';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const Map = React.lazy(() => import('../Map/Map'));

/**
 * PibResidenceMapSection - Embedded map section for PIB residence detail.
 * The Map component handles setting svgFocusId and hasPendingResidenceFocus
 * internally via the initialFocusId prop, and reacts to changes so switching
 * residences reuses the same google.maps.Map instance (avoids a billed
 * Dynamic Maps load per residence switch).
 */
const PibResidenceMapSection = ({ svgId }) => (
  <div
    id="map-scroll"
    className="detailSection pibPage-map"
  >
    <div id="pibPage-mapModalRoot" className="modalRootClass" />
    <Suspense fallback={<LoadingSpinner />}>
      <Map initialFocusId={svgId} />
    </Suspense>
  </div>
);

PibResidenceMapSection.propTypes = {
  svgId: propTypes.string.isRequired,
};

export default PibResidenceMapSection;
